import {
    FETCH_PRODUCT_LISTING_DETAILS_BEGIN,
    FETCH_PRODUCT_LISTING_DETAILS_SUCCESS,
    FETCH_PRODUCT_LISTING_DETAILS_FAILURE,
    FETCH_PRODUCT_LISTING_DETAILS_SUCCESS_AND_COMPARE,
    TOGGLE_COMPARE_STATE_FLAG,
    ADD_PRODUCT_TO_COMPARE,
    REMOVE_PRODUCT_FROM_COMPARE,
    RESET_COMPARE_DETAILS,
    SET_SELECTED_BRAND,
    RESET_PRODUCT_LISTING_DETAILS,
    FETCH_PRODUCT_LISTING_DETAILS_NETWORK_FAILURE
} from '../constants/productListingActionTypes';

const initialState = {
    productListPageValues: [],
    productListDescription: '',
    categoryName: '',
    subCategoryName: '',
    isLoading: true,
    inCompareState: false,
    compareProductsList: [],
    brandSelect: '',
    errorMessage: '',
    brandNames: [],
    valueFromAnotherPage: false,
    disableComparison: 0,
    networkError: {}
}

export default function (state, action) {
    if (typeof state === 'undefined') {
        state = initialState;
    }
    switch (action.type) {
        case FETCH_PRODUCT_LISTING_DETAILS_BEGIN:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_PRODUCT_LISTING_DETAILS_SUCCESS:
            return {
                ...state,
                productListPageValues: action.payload.result.productList,
                productListDescription: action.payload.result.description,
                categoryName: action.payload.result.parent,
                subCategoryName: action.payload.result.name,
                categoryId: action.payload.result.parentId,
                subCategoryId: action.payload.result.category,
                isLoading: false,
                brandSelect: action.payload.brandId ? action.payload.result.filter.find((brand) => brand.tid === action.payload.brandId) : (action.payload.result.filter.length > 0 ? action.payload.result.filter.find((brand) => brand.tid === 'all') : ''),
                brandNames: action.payload.result.filter,
                disableComparison: action.payload.result.disable_comparison
            };
        case FETCH_PRODUCT_LISTING_DETAILS_SUCCESS_AND_COMPARE:
            return {
                ...state,
                productListPageValues: action.payload.result.productList,
                productListDescription: action.payload.result.description,
                categoryName: action.payload.result.parent,
                subCategoryName: action.payload.result.name,
                categoryId: action.payload.result.parentId,
                subCategoryId: action.payload.result.category,
                isLoading: false,
                brandSelect: action.payload.result.filter.length > 0 ? (action.payload.brandId ? action.payload.result.filter.find((brand) => brand.tid === action.payload.brandId) : action.payload.result.filter.find((brand) => brand.tid === 'all')) : '',
                brandNames: action.payload.result.filter,
                inCompareState: true,
                valueFromAnotherPage: true,
                compareProductsList: action.payload.compareProductsList,
                disableComparison: action.payload.result.disable_comparison
            }
        case FETCH_PRODUCT_LISTING_DETAILS_FAILURE:
            return {
                ...state,
                errorMessage: action.payload,
                isLoading: false,
            };
        case FETCH_PRODUCT_LISTING_DETAILS_NETWORK_FAILURE:
            return {
                ...state,
                networkError: action.payload,
                isLoading: false,
            };
        case TOGGLE_COMPARE_STATE_FLAG:
            return {
                ...state,
                inCompareState: !state.inCompareState,
                compareProductsList: []
            }
        case ADD_PRODUCT_TO_COMPARE:
            return {
                ...state,
                valueFromAnotherPage: false,
                compareProductsList: [...state.compareProductsList, action.payload]
            }
        case REMOVE_PRODUCT_FROM_COMPARE:
            return {
                ...state,
                valueFromAnotherPage: false,
                compareProductsList: state.compareProductsList.filter(product => product.productId !== action.payload.productId)
            }

        case RESET_COMPARE_DETAILS:
            return {
                ...state,
                inCompareState: initialState.inCompareState,
                compareProductsList: [],
                valueFromAnotherPage: false
            }
        case SET_SELECTED_BRAND:
            return {
                ...state,
                brandSelect: action.payload
            }
        case RESET_PRODUCT_LISTING_DETAILS:
            return {
                ...state,
                productListPageValues: [],
                productListDescription: '',
                categoryName: '',
                subCategoryName: '',
                isLoading: true,
                inCompareState: false,
                compareProductsList: [],
                brandSelect: 'All Brands',
                errorMessage: ''
            }
        default:
            return state;
    }
}
